import {createRouter, createWebHistory} from 'vue-router'
import Organization from "@/views/pages/plateformOwner/Organization";
import CreateOrganization from "@/views/pages/plateformOwner/createOrganization";
import EditOrganization from "@/views/pages/plateformOwner/editOrganization";

import Role from "@/views/pages/permissions/Role";
import RoleCreate from "@/views/pages/permissions/createRole";
import RoleEdit from "@/views/pages/permissions/EditRole";

import SuperUserIndex from "@/views/pages/superUsers/index";
import SuperUserCreate from "@/views/pages/superUsers/create";
import SuperUserEdit from "@/views/pages/superUsers/edit";


import AdminRole from "@/views/pages/adminRoles/roles";
import AdminRoleIndex from "@/views/pages/adminRoles/index";
import AdminRoleCreate from "@/views/pages/adminRoles/create";
import AdminRoleEdit from "@/views/pages/adminRoles/edit";

import ViewUserCompetition from "@/views/pages/userAnswers/ViewUserCompetition";
import ViewUserTraining from "@/views/pages/userAnswers/ViewUserTraining";

import UserTraining from "@/views/pages/Training/user/UserTraining";
import UserTrainingPrivate from "@/views/pages/Training/user/user-privtae-training";
import UserCompetition from "@/views/pages/Competition/user/userCompetition";

import UserScore from "@/views/pages/score/UserScore";
import TeamScore from "@/views/pages/score/userTeamScore";


import Setting from "@/views/pages/Setting";
import Result from "@/views/pages/score/Result";
import ResultTeam from "@/views/pages/score/ResultTeam";
import IndexUserScore from "@/views/pages/score/indexUserScore";
import IndexTeamScore from "@/views/pages/score/IndexTeamScore";
import IndexUserTeamInCompetitions from "@/views/pages/score/IndexUserTeamInCompetitions";
import showResult from "@/views/pages/score/showResult";

import AnswerCompetition from "@/views/pages/answer/competition/index";
import AnswerTraining from "@/views/pages/answer/training/index";

import ViewModelAnswerComponent from "@/views/pages/userAnswers/ViewModelAnswerComponent";

// Template Routes
import Template from "@/views/pages/template/template";
import CreateTemplate from "@/views/pages/template/create";
import ViewTemplate from '@/views/pages/template/view';
import EditTemplate from "@/views/pages/template/update";

import settingEntities from "@/views/pages/entities/entites";
import settingEntityIndex from "@/views/pages/entities/index";
// import settingEntityCreate from "@/views/pages/entities/createEntity";
import settingEntityCreate from "@/views/pages/entities/create";
import settingEntityEdit from '@/views/pages/entities/editEntity';

import settingUser from "@/views/pages/user/user";
import settingUserIndex from "@/views/pages/user/index";
import settingUserCreate from "@/views/pages/user/createUser";
import settingUserUpdate from "@/views/pages/user/updateUser";

import settingTeam from "@/views/pages/team/team";
import settingTeamCreate from "@/views/pages/team/createTeam";
import settingTeamIndex from '@/views/pages/team/index';
import settingTeamUpdate from '@/views/pages/team/editTeam';

import CompetitionIndex from "@/views/pages/Competition/competition";
import CompetitionIndexCompleted from "@/views/pages/Competition/competition_completed";
import CompetitionIndexCompletedUser from "@/views/pages/Competition/user/competition_user_completed";
import CompetitionCreate from "@/views/pages/Competition/createCompetition";
import CompleteCompetition from '@/views/pages/Competition/CompleteCompetition';
import CompleteEditCompetition from '@/views/pages/Competition/CompleteEditCompetiton';
import ViewCompetition from '@/views/pages/Competition/ViewCompetition';
import EditCompetition from '@/views/pages/Competition/EditCompetition';

import Training from "@/views/pages/Training/training";
import TrainingPrivate from "@/views/pages/Training/private-training";
import TrainingCreate from "@/views/pages/Training/createTraining";
import CompleteTraining from "@/views/pages/Training/CompleteTraining";
import EditTraining from "@/views/pages/Training/EditTraining";
import CompleteEditTraining from "@/views/pages/Training/CompleteEditTraining";
import ViewTraining from '@/views/pages/Training/ViewTraining';

import Login from "@/views/pages/auth/Login";
import Wrapper from "@/views/pages/Wrapper";
import middleware from '../middleware';
import ForgetPassword from "@/views/pages/auth/ForgetPassword";
import Reset from "@/views/pages/auth/Reset";
import Profile from '@/views/pages/plateformOwner/Profile/Profile';
import ChangePassword from "@/views/pages/plateformOwner/Profile/ChangePassword";
import updateAdmin from "@/views/pages/auth/updateAdmin";
import NotFoundPage from '@/views/pages/NotFoundPage';


const routes = [

    {
        path: '/login',
        name: 'login-page',
        component: Login,
        beforeEnter: middleware.guest
    },
    // {
    //     path: '/forget-password',
    //     name: 'forget-password',
    //     component: ForgetPassword,
    //     beforeEnter: middleware.guest
    // },
    // {
    //     path: '/reset-password/:url',
    //     name: 'reset-password',
    //     component: Reset,
    //     beforeEnter: middleware.guest
    // },

    {
        path: '/organizations/edit/admin/:url',
        name: 'update-admin',
        component: updateAdmin,
        beforeEnter: middleware.guest
    },

    {
        path: '/',
        name: 'home-page',
        component: Wrapper,
        beforeEnter: middleware.user,
        children: [
            {
                path: '/organizations',
                name: 'organization',
                component: Organization,
                beforeEnter: middleware.canView
            },
            {
                path: '/create-organizations',
                name: 'create-organization',
                component: CreateOrganization,
                beforeEnter: middleware.canCreate
            },
            {
                path: '/edit-organizations/:id',
                name: 'edit-organization',
                component: EditOrganization,
                beforeEnter: middleware.canEdit
            },
            {
                path: '/profile',
                name: 'profile-page',
                component: Profile
            },
            // {
            //     path: '/change-password',
            //     name: 'change-password',
            //     component: ChangePassword
            // },
            {
                path: '/templates',
                name: 'template',
                component: Template,
                beforeEnter: middleware.canView
            },
            {
                path: '/templates/create',
                name: 'create-template',
                component: CreateTemplate,
                beforeEnter: middleware.canCreate,
            },
            {
                path: '/templates/view/:id',
                name: 'view-template',
                component: ViewTemplate,
                beforeEnter: middleware.canView,
            },
            {
                path: '/competitions',
                name: 'competition',
                component: CompetitionIndex,
                beforeEnter: middleware.canView
            },
            {
                path: '/completed/competition',
                name: 'completed-competition',
                component: CompetitionIndexCompleted,
                beforeEnter: middleware.canView
            },
            {
                path: '/completed/user/competition',
                name: 'completedUser-competition',
                component: CompetitionIndexCompletedUser,
                beforeEnter: middleware.canView
            },
            {
                path: '/create-competitions',
                name: 'create-competition',
                component: CompetitionCreate,
                beforeEnter: middleware.canCreate
            },
            {
                path: '/complete-competitions/:id',
                name: 'complete-competition',
                component: CompleteCompetition,
                beforeEnter: middleware.canCreate
            },
            {
                path: '/complete-edit-competitions/:id',
                name: 'complete-edit-competition',
                component: CompleteEditCompetition,
                beforeEnter: middleware.canView
            },
            {
                path: '/view-competitions/:id',
                name: 'view-competition',
                component: ViewCompetition,
                beforeEnter: middleware.canEdit
            },
            {
                path: '/edit-competitions/:id',
                name: 'edit-competition',
                component: EditCompetition,
                beforeEnter: middleware.canEdit
            },
            {
                path: '/user-competitions',
                name: 'userView-competition',
                component: UserCompetition,
                beforeEnter: middleware.canReadCompetition
            },
            {
                path: '/viewCompetitionUser/:id',
                name: 'viewUser-competition',
                component: ViewUserCompetition,
                beforeEnter: middleware.canReadCompetition
            },
            {
                path: '/trainings',
                name: 'training',
                component: Training,
                beforeEnter: middleware.canView
            },
            {
                path: '/private/trainings',
                name: 'private-training',
                component: TrainingPrivate,
                beforeEnter: middleware.canView
            },
            {
                path: '/create-trainings',
                name: 'create-training',
                component: TrainingCreate,
                beforeEnter: middleware.canCreate
            },
            {
                path: '/complete-trainings/:id',
                name: 'complete-training',
                component: CompleteTraining,
                beforeEnter: middleware.canCreate
            },
            {
                path: '/complete-edit-trainings/:id',
                name: 'complete-edit-training',
                component: CompleteEditTraining,
                beforeEnter: middleware.canView
            },
            {
                path: '/edit-trainings/:id',
                name: 'edit-training',
                component: EditTraining,
                beforeEnter: middleware.canEdit
            },
            {
                path: '/view-trainings/:id',
                name: 'view-training',
                component: ViewTraining,
                beforeEnter: middleware.canEdit
            },
            {
                path: '/user-trainings',
                name: 'userView-training',
                component: UserTraining,
                beforeEnter: middleware.canReadTraining
            },
            {
                path: '/user-private-trainings',
                name: 'userViewPrivate-training',
                component: UserTrainingPrivate,
                beforeEnter: middleware.canReadTraining
            },
            {
                path: '/user-score',
                name: 'userView-score',
                component: UserScore,
                beforeEnter: middleware.canReadScore
            },
            {
                path: '/user-team-score',
                name: 'teamView-score',
                component: TeamScore,
                beforeEnter: middleware.canReadScore
            },
            {
                path: '/viewTrainingUser/:id',
                name: 'viewUser-training',
                component: ViewUserTraining,
                beforeEnter: middleware.canReadTraining
            },
            {
                path: '/view/model/:id/answers',
                name: 'modelView-training',
                component: ViewModelAnswerComponent
            },
            {
                path: '/results',
                name: 'userscore-page',
                component: Result,
                beforeEnter: middleware.canView
            },
            {
                path: '/results/team',
                name: 'userscore-pageTeam',
                component: ResultTeam,
                beforeEnter: middleware.canView
            },
            {
                path: '/users/score/show/:id',
                name: 'pageShowUser-userscore',
                component: IndexUserScore,
                beforeEnter: middleware.canView
            },
            {
                path: '/competitions/teams/:id',
                name: 'pageShowTeams-userscore',
                component: IndexTeamScore,
                beforeEnter: middleware.canView
            },
            {
                path: '/competitions/teams/users/:id1/:id2',
                name: 'pageShowUserInTeams-userscore',
                component: IndexUserTeamInCompetitions,
                beforeEnter: middleware.canView
            },
            {
                path: '/results/show/:id1/:id2',
                name: 'pageShow-userscore',
                component: showResult,
                beforeEnter: middleware.canEdit
            },
            {
                path: '/roles',
                name: 'role-index',
                component: Role,
                beforeEnter: middleware.canViewRolesSuperAdmin
            },
            {
                path: '/create-role',
                name: 'role-create',
                component: RoleCreate,
                beforeEnter: middleware.canCreateRolesSuperAdmin
            },
            {
                path: '/edit-roles/:id',
                name: 'role-edit',
                component: RoleEdit,
                beforeEnter: middleware.canEditRolesSuperAdmin
            },
            {
                path: '/super/users',
                name: 'user-superIndex',
                component: SuperUserIndex,
                beforeEnter: middleware.canView
            },
            {
                path: '/super/users/create',
                name: 'user-superCreate',
                component: SuperUserCreate,
                beforeEnter: middleware.canCreateSuperUser
            },
            {
                path: '/super/users/edit/:id',
                name: 'user-superEdit',
                component: SuperUserEdit,
                beforeEnter: middleware.canEditSuperUser
            },
            {
                path: '/settings',
                name: 'setting',
                component: Setting,
                beforeEnter: middleware.canView,
                children: [
                    {
                        path: 'entities',
                        name: 'entities',
                        component: settingEntities,
                        children: [
                            {
                                path: '',
                                name: 'entities',
                                component: settingEntityIndex,
                                beforeEnter: middleware.canView,
                            }
                        ]
                    },
                    {
                        path: 'user',
                        name: 'user',
                        beforeEnter: middleware.canView,
                        component: settingUser,
                        children: [
                            {
                                path: '',
                                name: 'user',
                                component: settingUserIndex,
                                beforeEnter: middleware.canView,
                            },
                        ]
                    },
                    {
                        path: 'teams',
                        name: 'team',
                        component: settingTeam,
                        children: [
                            {
                                path: '',
                                name: 'entity',
                                component: settingTeamIndex,
                                beforeEnter: middleware.canView,
                            }
                        ]
                    },
                    {
                        path: 'roles',
                        name: 'role',
                        component: AdminRole,
                        children: [
                            {
                                path: '',
                                name: 'role-indexAdmin',
                                component: AdminRoleIndex,
                                beforeEnter: middleware.canViewRolesAdmin
                            },
                        ]
                    },
                ]
            },
            {
                path: '/settings/roles/create',
                name: 'role-createAdmin',
                component: AdminRoleCreate,
                beforeEnter: middleware.canCreateRolesAdmin
            },
            {
                path: '/settings/roles/edit/:id',
                name: 'role-editAdmin',
                component: AdminRoleEdit,
                beforeEnter: middleware.canEditRolesAdmin
            },
            {
                path: '/settings/teams/create',
                name: 'setting-entity-user-create',
                component: settingTeamCreate,
                beforeEnter: middleware.canCreate,
            },
            {
                path: '/settings/teams/edit/:id',
                name: 'setting-entity-user-update',
                component: settingTeamUpdate,
                beforeEnter: middleware.canEdit,
            },
            {
                path: '/settings/user/create',
                name: 'setting-user-create',
                component: settingUserCreate,
                beforeEnter: middleware.canCreate,
            },
            {
                path: '/settings/user/edit/:id',
                name: 'setting-user-update',
                component: settingUserUpdate,
                beforeEnter: middleware.canEdit,
            },
            {
                path: '/settings/entities',
                name: 'entities',
                component: settingEntities,
            },
            {
                path: '/settings/entities/create',
                name: 'setting-entity-create',
                component: settingEntityCreate,
                beforeEnter: middleware.canCreate,
            },
            {
                path: '/settings/entities/edit/:id',
                name: 'setting-entity-edit',
                component: settingEntityEdit,
                beforeEnter: middleware.canEdit,
            },

            {
                path: '/templates/edit/:id',
                name: 'organization-template-edit',
                component: EditTemplate,
                beforeEnter: middleware.canEdit,
            },

            {
                path: '/competition/:id/start',
                name: 'answer-competition',
                component: AnswerCompetition,
                beforeEnter: middleware.canAnswer
            }, {
                path: '/trainings/:id/start',
                name: 'answer-training',
                component: AnswerTraining,
                beforeEnter: middleware.canAnswer
            },
            

        ]
    },
    {
        path: '/:pathMatch(.*)*',
        name: "error",
        params:{
            code: 404,
            message: "Page Not Found"
        },
        component: NotFoundPage,
    },

];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
